
import { useEffect ,useState} from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getShopTimeInfobyID } from "../../../../store/actions/shopAction";

import ShopTimingEditCard from "../../../../utils/shoptimeEditCardView";


import {
  
    Button,
    ButtonToolbar,
    ButtonGroup,
    InputGroup,
    FormControl
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'

import {
   
    Divider,
 
} from '@mui/material'
import dayjs, { Dayjs } from 'dayjs';
import * as React from 'react';




const EditShopTimmingView = () => {


    const shopinfo= useSelector(state=>state.shopReducer);
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();
    let cntntUrl='/dashboard/shop/editTimebytrns/';
    let urlAddContnt='/dashboard/shop/timming/'+id;
    let urlNEXT='/dashboard/shopsevnts';
    const [loading,setLoading] = useState(true);

    const [openFrom, setOpenFrom] = React.useState(dayjs('2022-04-17T15:30'));
    const [openTo, setOpenTo] = React.useState(dayjs('2022-04-17T15:30'));
  
  const [brkFrom, setBrkFrom] = React.useState(dayjs('2022-04-17T15:30'));
  const [brkTo, setBrkTo] = React.useState(dayjs('2022-04-17T15:30'));
  
    const  goToOnclick=(data) => {
        //console.log(page)
        //dispatch(getPaginateArticles({page}))
        console.log('5555555555')
        console.log(data)
      //  shopinfo.currentContent=data;
      

        navigate(cntntUrl+data.shopId+'_'+data.dayID)
        console.log('5555555555')
        
        
    }  
    
    const getShoptime = (item,time,text) => {
         
       // console.log("#########");
    
        // LT	h:mm A	8:02 PM
        // LTS	h:mm:ss A	8:02:18 PM
        // L	MM/DD/YYYY	08/16/2018
        // LL	MMMM D, YYYY	August 16, 2018
        // LLL	MMMM D, YYYY h:mm A	August 16, 2018 8:02 PM
        // LLLL	dddd, MMMM D, YYYY h:mm A	Thursday, August 16, 2018 8:02 PM
        // l	M/D/YYYY	8/16/2018
        // ll	MMM D, YYYY	Aug 16, 2018
        // lll	MMM D, YYYY h:mm A	Aug 16, 2018 8:02 PM
        // llll	ddd, MMM D, YYYY h:mm A	Thu, Aug 16, 2018 8:02 PM
        
       
       

        const tm=text +dayjs(time).format('LT');
      
       // console.log(time)
        //console.log("#########");
        return tm;
    }



  

      useEffect(()=>{
        
    
        dispatch(getShopTimeInfobyID(id))
        .unwrap()
          .then(response => {
  
               setLoading(false);
if( response!==null){

    if(response.message==='success')
                    {
                        console.log("111111111111111");
    
                        
                        

                        console.log(response.timmimg.length)
                        console.log("666666666666666666");
                       if(response.timmimg.length===0)
                       {
                        
                        navigate(`/dashboard/shop/timming/${id}`)
                       }
                    
                    }
                     
   
         
                      }
  })
          
      },[id,dispatch])


    return(
        <>
        <hr/>
            <div className='adressInfocard'>

            <ButtonToolbar className='mb-3'>
                <ButtonGroup className='me-2'>
                    <LinkContainer to={urlAddContnt}>
                        <Button variant='secondary'>Add Time Info</Button>
                    </LinkContainer>
                </ButtonGroup>
                <form>
                    <InputGroup>
                        <InputGroup.Text id="btngrp1">@</InputGroup.Text>
                        <FormControl
                            type='text'
                            placeholder='Search'
                        />
                    </InputGroup>
                </form>
            </ButtonToolbar>
                
            <Divider className='mt-3 mb-3'/>
                
                <div>   

                {  shopinfo && shopinfo.currentTimenfo  && shopinfo.currentTimenfo.timmimg.length>>0 ?
                    <div className='mt-3 content'>

                { shopinfo.currentTimenfo.timmimg.map((item,i)=>(

                      <div key={i}>

                     
                  <ShopTimingEditCard item={item}
                   openFrom1={(item)=> getShoptime(item,item.openFrom,"OPEN TIME: ")}
                   openTo1={(item)=> getShoptime(item,item.openTo,"CLOSE TIME: ")}
                   brkFrom1={(item)=> getShoptime(item,item.brkFrom,"BREAK FROM: ")}
                   brkTo1={(item)=> getShoptime(item,item.brkTo,"BREAK TO: ")}
                  />
                        




                        <div className='form-group'>
                       <ButtonGroup className='me-2'>
                   
                        <Button 
                        variant='link'
                        color="orange"
                        onClick={()=>goToOnclick(item)}
                        >
                            Edit Time
                            </Button>
                    
                </ButtonGroup>
                </div>
            
                
                            </div>  
                            
                            
                               
                     
                                        
                                            
                        ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 
               <Divider className='mt-3 mb-3'/>
                <ButtonGroup className='me-2'>
                    <LinkContainer to={urlNEXT}>
                        <Button variant='primary'>NEXT</Button>
                    </LinkContainer>
                </ButtonGroup>
               
            </div>
           

        </>
    )
}

export default EditShopTimmingView;